export const PropertyUnavailableSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={201} height={200} fill="none">
    <path
      fill="#BABDD5"
      d="M187.571 135.062c-8.38 17.252-23.192 35.163-41.156 38.659-27.136 5.288-33.38 28.472-79.612 20.096-7.208-1.304-13.76-3.348-19.676-6a73.354 73.354 0 0 1-8.988-4.803C12.611 166.993 2.063 137.801 4.687 109.07 8.131 71.286 33.78 56.466 50.291 47.99c16.516-8.477 40.144-46.692 85.664-38.86 6.94 1.195 13.756 3.195 20.228 6.155 14.768 6.744 29.04 19.213 36.112 35.605a69.849 69.849 0 0 1 1.492 3.755c9.072 24.889 5.208 56.897-6.216 80.417Z"
    />
    <path
      fill="#fff"
      d="M187.571 135.062c-8.38 17.252-23.192 35.163-41.156 38.659-27.136 5.288-33.38 28.472-79.612 20.096-7.208-1.304-13.76-3.348-19.676-6a73.354 73.354 0 0 1-8.988-4.803C12.611 166.993 2.063 137.801 4.687 109.07 8.131 71.286 33.78 56.466 50.291 47.99c16.516-8.477 40.144-46.692 85.664-38.86 6.94 1.195 13.756 3.195 20.228 6.155 14.768 6.744 29.04 19.213 36.112 35.605a69.849 69.849 0 0 1 1.492 3.755c9.072 24.889 5.208 56.897-6.216 80.417Z"
      opacity={0.7}
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M185.17 37.358s-7.777-11.992-13.937-11.34c-6.156.648-5.832 5.184-8.1 8.748-2.268 3.564-5.832-1.62-9.396-.324-3.564 1.296-2.267 3.564-4.535 4.536-2.268.972-7.452-4.212-9.396-2.592-1.944 1.62-2.592 4.212-3.888 4.86-1.296.648-3.889-1.62-5.185 0l-1.295 1.62h63.515s.972-3.564-1.62-5.184c-2.6-1.62-3.247.324-6.163-.324ZM106.541 25.583s-4.616-7.112-8.268-6.728c-3.652.384-3.46 3.076-4.808 5.192-1.344 2.116-3.46-.96-5.576-.192-2.116.768-1.344 2.116-2.692 2.692-1.344.576-4.424-2.5-5.576-1.54-1.152.96-1.54 2.5-2.308 2.884-.768.384-2.308-.96-3.076 0l-.768.96h37.684s.576-2.116-.96-3.076-1.92.192-3.652-.192Z"
    />
    <path
      fill="#BABDD5"
      d="M73.443 169.132c-.292-2.444-2.188-7.288-4.908-8.648-2.884-1.44-5.044 1.852-10.196 4.22-5.148 2.368-3.808-1.752-9.164-4.944s-6.076 1.236-8.236 2.264c-2.236 1.064-3.556-2.852-4.084-4.304-1.032-2.84-2.232-5.276-4.9-6.964-4.124-2.604-11.176-2.4-13.356 2.648-.656 1.516-.42 4.296-2.064 5.12-2.472 1.236-8.856-.204-9.268 3.912-.144 1.428.284 2.696.908 3.748.18.548.32 1.124.228 1.404-.204.616-1.544-.824-2.676-.104-.736.468-1.252 1.196-1.524 1.648h69.24Z"
    />
    <path
      fill="#fff"
      d="M24.948 154.902s-.176.824.192 1.508.876 1.136.876 1.136.364-1.3-1.068-2.644ZM18.04 162.176s.635.552 1.411.56a4.668 4.668 0 0 0 1.42-.216s-.964-.952-2.832-.344ZM11.297 161.244s.636.552 1.412.56c.776.008 1.42-.216 1.42-.216s-.964-.948-2.832-.344ZM17.07 165.592s.772.34 1.516.116a4.698 4.698 0 0 0 1.292-.628s-1.204-.62-2.808.512ZM10.227 164.722s.772.34 1.516.116c.744-.224 1.292-.628 1.292-.628s-1.204-.624-2.808.512ZM21.68 165.949s.844-.012 1.424-.524c.584-.512.912-1.108.912-1.108s-1.348-.068-2.336 1.632ZM12.102 168.386s.844-.012 1.424-.524c.584-.512.912-1.108.912-1.108s-1.348-.068-2.336 1.632ZM19.734 155.754s.192.82.816 1.28c.628.46 1.276.656 1.276.656s-.22-1.336-2.092-1.936ZM33.48 155.145s-.837.12-1.349.7a4.73 4.73 0 0 0-.764 1.216s1.344-.108 2.112-1.916ZM36.363 159.483s-.824-.176-1.508.192a4.702 4.702 0 0 0-1.136.876s1.304.364 2.644-1.068ZM36.081 164.403s-.596-.596-1.368-.66a4.747 4.747 0 0 0-1.432.116s.892 1.016 2.8.544ZM32.858 167.051s-.344-.772-1.044-1.104a4.776 4.776 0 0 0-1.377-.404s.468 1.268 2.42 1.508ZM31.159 159.059s-.836.12-1.348.7a4.73 4.73 0 0 0-.764 1.216s1.344-.108 2.112-1.916ZM17.484 157.973s.372.756 1.084 1.064a4.603 4.603 0 0 0 1.392.348s-.516-1.248-2.476-1.412ZM29.386 153.98s-.676.504-.848 1.26c-.172.76-.088 1.432-.088 1.432s1.136-.736.936-2.692ZM26.836 151.598s-.384.752-.2 1.504c.18.756.552 1.324.552 1.324s.692-1.16-.352-2.828ZM21.32 152.402s0 .844.504 1.432 1.096.928 1.096.928.084-1.348-1.6-2.36ZM45.423 161.316s-.104.48.112.876c.217.396.509.66.509.66s.212-.752-.62-1.536ZM41.414 165.547s.368.32.82.324c.452.004.824-.124.824-.124s-.56-.552-1.644-.2ZM40.852 167.527s.448.196.88.068c.432-.132.748-.364.748-.364s-.696-.36-1.628.296ZM43.523 167.733s.488-.008.828-.304c.34-.3.528-.644.528-.644s-.784-.04-1.356.948ZM42.398 161.816s.112.476.476.744.74.38.74.38-.132-.772-1.216-1.124ZM50.376 161.465s-.484.068-.784.408c-.296.34-.444.704-.444.704s.784-.06 1.228-1.112ZM52.06 163.978s-.48-.104-.877.112c-.396.216-.66.508-.66.508s.756.212 1.536-.62ZM51.894 166.841s-.344-.348-.796-.384c-.448-.036-.832.068-.832.068s.52.588 1.628.316ZM50.013 168.376s-.2-.448-.604-.64a2.761 2.761 0 0 0-.8-.232s.272.732 1.404.872ZM49.033 163.734s-.484.068-.784.408c-.296.34-.444.704-.444.704s.784-.064 1.228-1.112ZM41.094 163.102s.216.44.632.616c.416.18.808.204.808.204s-.3-.724-1.44-.82ZM48 160.785s-.391.292-.491.732c-.1.44-.052.832-.052.832s.66-.428.544-1.564ZM46.528 159.402s-.224.436-.116.876c.104.44.32.768.32.768s.4-.676-.204-1.644ZM43.32 159.867s0 .488.292.832.636.54.636.54.052-.784-.928-1.372ZM65.338 163.176s-.104.48.112.876c.215.396.507.66.507.66s.213-.752-.62-1.536ZM61.336 167.406s.368.32.82.324c.452.004.824-.124.824-.124s-.56-.552-1.644-.2ZM62.32 163.676s.112.476.476.744.74.38.74.38-.132-.772-1.216-1.124ZM70.29 163.324s-.484.068-.784.408c-.296.34-.444.704-.444.704s.785-.06 1.228-1.112ZM71.974 165.838s-.48-.104-.877.112c-.395.216-.66.508-.66.508s.757.212 1.537-.62ZM71.808 168.7s-.344-.348-.796-.384c-.448-.036-.832.068-.832.068s.516.588 1.628.316ZM68.947 165.594s-.484.068-.784.408c-.296.34-.444.704-.444.704s.784-.064 1.228-1.112ZM61.008 164.965s.216.44.632.616c.416.18.808.204.808.204s-.304-.724-1.44-.82ZM67.915 162.645s-.392.292-.492.732c-.1.44-.052.832-.052.832s.66-.428.544-1.564ZM66.434 161.262s-.224.436-.115.876c.103.44.32.768.32.768s.4-.676-.204-1.644ZM63.234 161.727s0 .488.292.832.636.54.636.54.048-.784-.928-1.372Z"
    />
    <path
      fill="#A1A1A1"
      d="M23.232 169.131h1.836l-.804-4.12 3.808-2.988-4.324 2.06-1.236-5.868 1.032 10.708-2.68-1.028-5.044-1.956 5.56 3.088 1.852.104ZM45.995 163.57l-2.472 5.352 1.028.104.62-1.544 2.752-.496-2.548-.536.62-2.88ZM64.219 166.145l1.444 2.884.248-1.56-1.692-1.324ZM66.908 169.129l.208-2.1 1.84-1.404-1.732.308.292-2.984-1.852 6.076.616.104h.628Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M188.067 105.609H45.219v63.516h142.848v-63.516Z"
    />
    <path
      fill="#BABDD5"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M184.399 105.609H48.875v63.516h135.524v-63.516ZM61.438 95.852H171.84l-55.2-45.36-55.204 45.36Z"
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.2}
      d="M109.141 53.887h13.952M106.055 57.371h21.56M101.164 60.855h30.44M97.719 64.34h38.232M92.828 67.824h47.108M88.844 71.309h55.264M84.86 74.793h63.415M80.508 78.277H152.8M76.164 81.758h81.172M71.813 85.242h89.327M68.188 88.727h97.479M63.297 92.21h106.536"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M193.715 107.909H39.567c-1.96 0-3.644-1.308-4.004-3.112l-.172-.859h162.496l-.172.859c-.356 1.8-2.036 3.112-4 3.112Z"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="m56.823 95.852-21.432 8.084h162.496l-21.436-8.084H56.823Z"
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.2}
      d="M50.484 110.973h132.664M50.484 114.457h132.664M50.484 117.941h132.664M50.484 121.426h132.664M50.484 124.91h132.664M50.484 128.395h132.664M50.484 131.879h132.664M50.484 135.363h132.664M50.484 138.848h132.664M50.484 142.332h132.664M50.484 145.816h132.664M50.484 149.301h132.664M50.484 152.785h132.664M50.484 156.27h132.664M50.484 159.754h132.664M50.484 163.238h132.664"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M168.473 119.141H64.813v49.984h103.66v-49.984Z"
    />
    <path
      fill="#E3E3E3"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M164.387 122.844H68.891v46.284h95.496v-46.284Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M116.644 46.703 56.828 95.851h4.612l55.204-45.36 55.2 45.36h4.612l-59.812-49.148Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M126.03 59.582h-18.788V74.65h18.788V59.582Z"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M120.567 59.71h-7.864V74.52h7.864V59.71Z"
    />
    <path fill="#fff" d="M116.993 59.71h-.704V74.52h.704V59.71Z" />
    <path fill="#fff" d="M120.731 66.762h-8.169v.704h8.169v-.704Z" />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.2}
      d="M107.859 60.48h4.164M107.859 61.082h4.164M107.859 61.688h4.164M107.859 62.293h4.164M107.859 62.895h4.164M107.859 63.5h4.164M107.859 64.106h4.164M107.859 64.707h4.164M107.859 65.313h4.164M107.859 65.918h4.164M107.859 67.95h4.164M107.859 68.55h4.164M107.859 69.16h4.164M107.859 69.762h4.164M107.859 70.363h4.164M107.859 70.973h4.164M107.859 71.574h4.164M107.859 72.176h4.164M107.859 72.781h4.164M107.859 73.387h4.164M121.211 60.48h4.168M121.211 61.082h4.168M121.211 61.688h4.168M121.211 62.293h4.168M121.211 62.895h4.168M121.211 63.5h4.168M121.211 64.106h4.168M121.211 64.707h4.168M121.211 65.313h4.168M121.211 65.918h4.168M121.211 67.95h4.168M121.211 68.55h4.168M121.211 69.16h4.168M121.211 69.762h4.168M121.211 70.363h4.168M121.211 70.973h4.168M121.211 71.574h4.168M121.211 72.176h4.168M121.211 72.781h4.168M121.211 73.387h4.168"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="m189.512 109.556-.804.48a2.481 2.481 0 0 0-1.188 2.132v55.388h-1.848v-55.388c0-1.528.804-2.956 2.092-3.724l.804-.48a2.481 2.481 0 0 0 1.188-2.132v-.512h1.848v.512c0 1.532-.8 2.956-2.092 3.724Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M184.736 116.984h3.256v-.956h-3.256v.956ZM184.736 131.258h3.256v-.956h-3.256v.956ZM184.736 145.527h3.256v-.956h-3.256v.956ZM184.736 159.797h3.256v-.956h-3.256v.956Z"
    />
    <path fill="#CCC" d="M81.707 159.031h-5.52v4.256h5.52v-4.256Z" />
    <path fill="#969696" d="M87.242 159.949h-4.328v3.336h4.328v-3.336Z" />
    <path
      fill="#CCC"
      d="M101.336 159.949h-4.328v3.336h4.328v-3.336ZM85.922 152.934h-4.328v3.336h4.328v-3.336ZM98.016 152.934h-4.329v3.336h4.329v-3.336ZM80.539 132.176H76.21v3.336h4.328v-3.336ZM86.398 132.176H82.07v3.336h4.328v-3.336Z"
    />
    <path
      fill="#969696"
      d="M95.897 132.176h-7.96v3.336h7.96v-3.336ZM103.195 152.934h-4.328v3.336h4.328v-3.336Z"
    />
    <path
      fill="#CCC"
      d="M102.623 145.977h-9.084v3.336h9.084v-3.336ZM85.482 139.016h-9.084v3.336h9.084v-3.336ZM92.943 139.016h-1.42v3.336h1.42v-3.336ZM95.13 139.016h-1.42v3.336h1.42v-3.336ZM97.318 139.016h-1.42v3.336h1.42v-3.336ZM80.115 152.934h-1.42v3.336h1.42v-3.336Z"
    />
    <path fill="#969696" d="M86.865 145.977h-9.084v3.336h9.084v-3.336Z" />
    <path
      fill="#CCC"
      d="M102.621 144.309h-5.504v1.668h5.504v-1.668ZM96.5 158.668h-4.328v4.62H96.5v-4.62Z"
    />
    <path
      fill="#222"
      d="M90.646 136.734h-1.052v5.604h1.052v-5.604ZM90.646 143.723h-1.052v5.604h1.052v-5.604ZM90.646 150.707h-1.052v5.604h1.052v-5.604Z"
    />
    <path
      fill="#222"
      d="M105.629 134.02v1.408H74.617v-1.408h-.844v34.96h.952v-4.3h30.804v4.3h.952v-34.96h-.852Zm-.104 29.28H74.721v-5.604h30.804v5.604Zm0-6.988H74.721v-5.604h30.804v5.604Zm0-6.984H74.721v-5.604h30.804v5.604Zm0-6.988H74.721v-5.604h30.804v5.604Z"
    />
    <path fill="#222" d="M90.654 157.695h-1.052v5.604h1.052v-5.604Z" />
    <path
      fill="#E3E3E3"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M155.194 130.383h-15.616v38.744h15.616v-38.744Z"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M142.317 149.486a.92.92 0 1 0-1.84 0 .92.92 0 0 0 1.84 0Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="m43.819 109.564.804.48a2.481 2.481 0 0 1 1.188 2.132v55.388h1.848v-55.388c0-1.528-.804-2.956-2.092-3.724l-.804-.48a2.481 2.481 0 0 1-1.188-2.132v-.512h-1.848v.512c0 1.532.8 2.956 2.092 3.724Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M48.6 116.035h-3.256v.956H48.6v-.956ZM48.6 130.305h-3.256v.956H48.6v-.956ZM48.6 144.574h-3.256v.956H48.6v-.956ZM48.6 158.844h-3.256v.956H48.6v-.956Z"
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M196.694 169.133H2.914"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M127.195 144.877s.26-1.084.824-1.256c.564-.172 2.34.088 2.816.388.476.304.692 1.3.304 1.732-.388.432-2.664 1.052-2.664 1.052l-1.28-1.916Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M127.289 145.051s.236-.856.744-.996c.508-.136 2.116.068 2.548.308.432.24.628 1.028.276 1.372-.352.344-2.412.832-2.412.832l-1.156-1.516Z"
    />
    <path
      fill="#BABDD5"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M130.855 150.054c-.528-1.34-2.156-3.26-2.156-3.26s-5.608-8.576-5.752-8.72c-.144-.144-1.008-1.152-2.924-1.436-1.484-.224-6.396-.444-8.532-.536-2.136.088-7.044.312-8.532.536-1.916.288-2.78 1.292-2.924 1.436-.144.144-5.752 8.72-5.752 8.72s-1.628 1.916-2.156 3.26c-.528 1.34-1.244 4.744-1.244 4.744h41.216c.004 0-.716-3.404-1.244-4.744Z"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M126.685 144.683c-.48-1.2-3.736-5.512-4.072-5.896-.336-.384-.864-.96-1.724-.96-.38 0-2.42-.072-4.592-.156a124.02 124.02 0 0 0-9.604 0c-2.172.084-4.212.156-4.592.156-.864 0-1.388.576-1.724.96-.336.384-3.596 4.696-4.072 5.896-.48 1.2-.672 1.58-.672 1.58s9.028-.58 15.864-.62c6.836.04 15.864.62 15.864.62s-.196-.38-.676-1.58ZM129.373 169.027h-3.352a.724.724 0 0 1-.724-.724v-5.7c0-.596.484-1.08 1.08-1.08h2.64c.596 0 1.08.484 1.08 1.08v5.696a.72.72 0 0 1-.724.728ZM97.318 169.027h-3.352a.724.724 0 0 1-.724-.724v-5.7c0-.596.484-1.08 1.08-1.08h2.64c.596 0 1.08.484 1.08 1.08v5.696a.722.722 0 0 1-.724.728Z"
    />
    <path
      fill="#BABDD5"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M132.101 154.797H90.885s-.768.96-.768 1.436.288 5.224.768 5.944c.48.72.72 1.056 1.436 1.292.68.228 17.444.024 19.168 0 1.724.02 18.488.224 19.168 0 .72-.24.96-.576 1.436-1.292.48-.72.768-5.464.768-5.944 0-.48-.76-1.436-.76-1.436Z"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M126.833 150.055H96.938v3.892h29.895v-3.892Z"
    />
    <path
      fill="#C7C7C7"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="m99.608 154.796-3.832-6.804s-1.868.288-2.492 1.152c-.624.864-1.292 5.608-1.292 5.608l7.616.044Z"
    />
    <path
      fill="#7D7D7D"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="m96.938 150.052-1.16-2.06s-1.868.288-2.492 1.152c-.124.172-.252.5-.372.912h4.024v-.004Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M92.188 153.5c-.12.728-.196 1.244-.196 1.244l7.62.048-.728-1.292h-6.696Z"
    />
    <path
      fill="#C7C7C7"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="m123.43 154.796 3.832-6.804s1.868.288 2.492 1.152c.624.864 1.292 5.608 1.292 5.608l-7.616.044Z"
    />
    <path
      fill="#7D7D7D"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="m126.102 150.052 1.16-2.06s1.868.288 2.492 1.152c.124.172.252.5.372.912h-4.024v-.004Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M130.854 153.5c.12.728.196 1.244.196 1.244l-7.62.048.728-1.292h6.696Z"
    />
    <path
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M111.031 146.887a99.482 99.482 0 0 0-7.948.344l-6.88.572M122.367 147.447l-3.14-.248a99.777 99.777 0 0 0-7.336-.312M126.826 147.803l-3.396-.272"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M115.584 150.008h-7.396v3.94h7.396v-3.94Z"
    />
    <path
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M129.375 158.074h2.792M90.672 158.074h37.472"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M94.968 163.957a.814.814 0 0 0-.816-.816.814.814 0 0 0-.816.816c0 .452.364.816.816.816a.814.814 0 0 0 .816-.816ZM95.574 144.877s-.26-1.084-.824-1.256c-.564-.172-2.34.088-2.816.388-.476.304-.692 1.3-.304 1.732.388.432 2.664 1.052 2.664 1.052l1.28-1.916Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M95.476 145.051s-.236-.856-.744-.996c-.508-.136-2.12.068-2.548.308-.432.24-.628 1.028-.276 1.372.352.344 2.412.832 2.412.832l1.156-1.516ZM122.513 138.677c-.336-.372-.844-.844-1.624-.844-.38 0-2.42-.072-4.592-.156-.748-.028-1.496-.048-2.244-.064l-18.248 8.28c-.12.272-.172.376-.172.376s6.004-.388 11.924-.552l14.956-7.04ZM127.258 146.05c-.1-.228-.284-.648-.568-1.364-.2-.5-.884-1.544-1.64-2.62l-8.144 3.696c4.392.148 8.552.388 9.956.476l.396-.188Z"
    />
    <path
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M129.579 162.688H93.387a.519.519 0 1 1 0-1.04h36.196a.519.519 0 1 1-.004 1.04Z"
    />
  </svg>
)
